import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';

import { Observable } from 'rxjs/Observable';
import { saveFile } from '../helpers/file-download';
import { BaseHttpService } from './base-http.service';
import { EventRequestModel, Permission, AcknowledgementPermission, EventRequestChangeStatusType, EventRequesAcknowledgeModel, EventRequesAcknowledgeListModel, RequestBuildingUnitView, CompanyBuildingUnitView, PaginationModel, PagedResult, EventRequestTotals, EventRequestAutocomplete, VenueMeetingItem, RequestCharge, Supplier } from '../models';
import { SupplierRequestsModel, InvoiceFile, GeneralLookup } from '@app/core';

@Injectable()
export class SupplierService extends BaseHttpService<any> {

  constructor(private http: HttpClient) {
    super('supplier');
  }

  AddSupplierRequest(formData: FormData): Observable<any> {
    return this.http
      .post(this.getApiURI() + '/supplier/AddSupplier', formData, { headers: new HttpHeaders({ 'RequestWithFiles': 'RequestWithFiles' }) })
      .catch(this.handleError)

  }
  UploadInvoice(formData: FormData): Observable<any> {
    return this.http
      .post(this.getApiURI() + '/invoices/SaveInvoice', formData, { headers: new HttpHeaders({ 'RequestWithFiles': 'RequestWithFiles' }) })
      .catch(this.handleError)

  }
  getSupplierRequests(model: { paginationModel: PaginationModel, pendingOnly: boolean, requestStatusId: number, requestNo: string, requestId: number }): Observable<PagedResult<SupplierRequestsModel>> {
    return this.http
      .get(this.getApiURI() + '/Supplier/GetSupplierRequests' + `?pagingParameters.pageNumber=${model.paginationModel.pageNumber}&pagingParameters.pageSize=${model.paginationModel.pageSize}&pagingParameters.orderBy=${model.paginationModel.orderBy}&pendingOnly=${model.pendingOnly}&requestStatusId=${model.requestStatusId}&requestNo=${model.requestNo}&requestId=${model.requestId}`)
      .catch(this.handleError)
  }

 
  pushSupplier(requestId: number): Observable<any> {
    return this.httpClient
      .put(this.getApiURI() + `/supplier/${requestId}/push-supplier`, {})
      .catch(this.handleError)
  }
  approveSupplierByFreezone(requestId: number ): Observable<any> {
    return this.httpClient
      .put(this.getApiURI() + `/supplier/${requestId}/approve-supplier-freezone`, {})
      .catch(this.handleError)
  }
  rejectSupplierByTenant(requestId: number, comments: string): Observable<any> {
    return this.httpClient
      .put(this.uri + `${requestId}/reject-Supplier-tenant`, { comments: comments })
      .catch(this.handleError)
  }
  rejectSupplierByTSD(requestId: number, comments: string): Observable<any> {
    return this.httpClient
      .put(this.uri + `${requestId}/reject-supplier-TSD`, { comments: comments })
      .catch(this.handleError)
  }
  revokeSupplier(requestId: number, comments: string): Observable<any> {
    return this.httpClient
      .put(this.uri + `${requestId}/revoke-supplier`, { comments: comments })
      .catch(this.handleError)
  }
  cancelSupplierByTSD(requestId: number, comments: string): Observable<any> {
    return this.httpClient
      .put(this.uri + `${requestId}/cancel-supplier-TSD`, { comments: comments })
      .catch(this.handleError)
  }
  editTargetTenant(requestId: number, targetTenant: string): Observable<any> {
    return this.httpClient
      .put(this.uri + `${requestId}/edit-target-tenant`, { targetTenant: targetTenant })
      .catch(this.handleError)
  }
  getTargetTenants(SupplierId: number): Observable<number[]> {
    let Params = new HttpParams().set('SupplierId', String(SupplierId));

    return this.http
      .get(this.getApiURI() + "/Supplier/GetTargetTenants", { params: Params })
      .catch(this.handleError)
  }


  getSuppliers(): Observable<Supplier[]> {
    return this.http
      .get(this.getApiURI() + '/Supplier/GetSuppliers')
      .catch(this.handleError)
  }

  updateSupplier(formData: FormData): Observable<any> {
    return this.http
      .post(this.getApiURI() + '/supplier/UpdateSupplier', formData, { headers: new HttpHeaders({ 'RequestWithFiles': 'RequestWithFiles' }) })
      .catch(this.handleError)

  }


}



// WEBPACK FOOTER //
// ./src/app/core/data/supplier.service.ts